// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Filter_wrap__hU8xs {
  position: relative;
  width: max-content;
}
@media (max-width: 1200px) {
  .Filter_wrap__hU8xs {
    overflow: hidden;
  }
}

.Filter_drop__SLR7C {
  position: absolute;
  left: 0;
  top: calc(100% + 4px);
  min-width: 256px;
  width: auto;
  background-color: var(--white);
  border: 1px solid var(--gray-100);
  border-radius: 4px;
  padding: 8px;
  z-index: 2;
}
.Filter_drop__SLR7C .ScrollbarsCustom-TrackY {
  top: 0;
  height: 100%;
}
.Filter_drop__SLR7C .employees__grid {
  display: block;
}
.Filter_drop__SLR7C .searchBlock {
  margin-bottom: 4px;
}

.Filter_search__OmpVc {
  margin-bottom: 4px;
}
.Filter_search__OmpVc input {
  padding-left: 6px;
}

.Filter_label__CLSp2 {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 400;
}
.Filter_label__CLSp2 .btn__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: initial;
  transform: none;
}
.Filter_label--opened__NZtGm {
  background: #EEEEEE !important;
  color: var(--text-color) !important;
}
.Filter_label--opened__NZtGm .btn__icon {
  transform: rotate(180deg);
}
.Filter_label__CLSp2 .Filter_btn__text-container__k9da8 {
  max-width: 600px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
@media (max-width: 640px) {
  .Filter_label__CLSp2 .Filter_btn__text-container__k9da8 {
    max-width: 100%;
  }
}
.Filter_label--is-active__JK0sT {
  background: var(--accent-color);
  color: var(--white);
}

.Filter_list-container__RqkGb {
  overflow: auto;
  margin-bottom: 16px;
  max-height: 220px;
}
@media (max-width: 1200px) {
  .Filter_list-container__RqkGb {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-height: 320px;
  }
}

.Filter_item-container__ruXxx {
  display: flex;
  align-items: center;
  gap: 12px;
}
@media (max-width: 1200px) {
  .Filter_item-container__ruXxx {
    padding: 4px 0 0;
    align-items: flex-start;
  }
}
.Filter_item-container__ruXxx:last-child .Filter_item__5TZpW {
  border: none;
}

.Filter_checkbox__LGFwZ {
  width: 22px;
  height: 22px;
  margin: 0;
  padding: 0;
}
.Filter_checkbox__LGFwZ div {
  margin-top: 0;
}
.Filter_checkbox__LGFwZ p {
  margin: 0 !important;
  padding: 0 !important;
  border-bottom: 0;
}

.Filter_item__5TZpW {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--gray-100);
  width: 100%;
  transition: var(--transition);
  padding: 6px 4px;
  cursor: pointer;
  font-size: 12px;
  line-height: 16px;
  gap: 8px;
}
@media (hover: hover) {
  .Filter_item__5TZpW:hover {
    background-color: var(--accent-color);
    color: var(--white);
  }
  .Filter_item__5TZpW:hover .Filter_check-icon__fMiBR svg path {
    fill: var(--white);
  }
}
.Filter_item__5TZpW .Filter_check-icon__fMiBR {
  width: 16px;
  height: 16px;
  margin-left: auto;
}
.Filter_item__5TZpW .Filter_check-icon__fMiBR svg {
  fill: var(--accent-color);
}
@media (max-width: 1200px) {
  .Filter_item__5TZpW {
    padding: 0 0 14px 0;
    font-size: 14px;
  }
}

.Filter_avatar__1kW7\\+ {
  width: 24px;
  height: 24px;
}

.Filter_btn-container__L12an {
  display: flex;
  gap: 4px;
  margin-top: 8px;
  justify-content: flex-end;
}
.Filter_btn-container__L12an button {
  padding: 6px 18px;
  height: auto;
  border-radius: 8px;
}
.Filter_btn-container__L12an button:last-child {
  width: 100%;
  max-width: 160px;
}
@media (max-width: 1200px) {
  .Filter_btn-container__L12an button:last-child {
    max-width: initial;
  }
}

.Filter_members__one__OMQUC {
  display: flex;
  align-items: center;
  gap: 4px;
}
.Filter_members__more__1hoN2 {
  display: flex;
}
.Filter_members__Gpqcz .Filter_member-avatar__2XGM0 {
  position: relative;
  width: 16px;
  height: 16px;
  border: 1px solid var(--accent-color);
  font-size: 7px;
}
.Filter_members__Gpqcz .Filter_member-container__M3W1q {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Filter_fake-input__KR2-u {
  display: flex;
  align-items: center;
  padding: 6px;
  background: #F0F1F5;
  border-radius: 4px;
  width: 100%;
  margin-bottom: 4px;
}
.Filter_fake-input__date__2zKFm {
  color: var(--text-color);
  font-size: 14px;
  line-height: 22.12px;
}
.Filter_fake-input__icon__fen-W {
  width: 16px;
  height: 16px;
  margin-left: auto;
}

.Filter_datepicker-container__Rrjc1 {
  display: flex;
  position: relative;
}
.Filter_datepicker-container__Rrjc1 .multiPicker__wp {
  width: 100%;
}
.Filter_datepicker-container__Rrjc1 .multiPicker__wp .multiPicker {
  position: initial;
  padding: 0;
  border: none;
  box-shadow: none;
}

.Filter_nothingListContainer__u1DgQ {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.Filter_skeleton__luTwb {
  width: 100%;
  height: 37px;
}

.Filter_no-results__3XkDA {
  text-align: center;
  font-size: 16px;
  line-height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Filter/Filter.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,kBAAA;AACF;AACE;EAJF;IAKI,gBAAA;EAEF;AACF;;AACA;EACE,kBAAA;EACA,OAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,8BAAA;EACA,iCAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAEF;AACI;EACE,MAAA;EACA,YAAA;AACN;AAEI;EACE,cAAA;AAAN;AAGI;EACE,kBAAA;AADN;;AAMA;EACE,kBAAA;AAHF;AAKE;EACE,iBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAJF;AAOI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;AALN;AASE;EACE,8BAAA;EACA,mCAAA;AAPJ;AAUM;EACE,yBAAA;AARR;AAaE;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAXJ;AAaI;EANF;IAOI,eAAA;EAVJ;AACF;AAaE;EACE,+BAAA;EACA,mBAAA;AAXJ;;AAeA;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;AAZF;AAcE;EALF;IAMI,aAAA;IACA,sBAAA;IACA,QAAA;IACA,iBAAA;EAXF;AACF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAXF;AAaE;EALF;IAMI,gBAAA;IACA,uBAAA;EAVF;AACF;AAaI;EACE,YAAA;AAXN;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAbF;AAeE;EACE,aAAA;AAbJ;AAgBE;EACE,oBAAA;EACA,qBAAA;EACA,gBAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,QAAA;AAfF;AAiBE;EACE;IACE,qCAAA;IACA,mBAAA;EAfJ;EAmBQ;IACE,kBAAA;EAjBV;AACF;AAuBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AArBJ;AAuBI;EACE,yBAAA;AArBN;AAyBE;EArCF;IAsCI,mBAAA;IAEA,eAAA;EAvBF;AACF;;AA0BA;EACE,WAAA;EACA,YAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;AAvBF;AAyBE;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;AAvBJ;AAyBI;EACE,WAAA;EACA,gBAAA;AAvBN;AAyBM;EAJF;IAKI,kBAAA;EAtBN;AACF;;AA6BE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA1BJ;AA6BE;EACE,aAAA;AA3BJ;AA8BE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,cAAA;AA5BJ;AA+BE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA7BJ;;AAmCA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAhCF;AAkCE;EACE,wBAAA;EACA,eAAA;EACA,oBAAA;AAhCJ;AAmCE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAjCJ;;AAqCA;EACE,aAAA;EACA,kBAAA;AAlCF;AAqCI;EACE,WAAA;AAnCN;AAqCM;EACE,iBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AAnCR;;AAyCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAtCF;;AAyCA;EACE,WAAA;EACA,YAAA;AAtCF;;AAyCA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AAtCF","sourcesContent":[".wrap {\n  position: relative;\n  width: max-content;\n\n  @media (max-width: 1200px) {\n    overflow: hidden;\n  }\n}\n\n.drop {\n  position: absolute;\n  left: 0;\n  top: calc(100% + 4px);\n  min-width: 256px;\n  width: auto;\n  background-color: var(--white);\n  border: 1px solid var(--gray-100);\n  border-radius: 4px;\n  padding: 8px;\n  z-index: 2;\n\n  :global {\n    .ScrollbarsCustom-TrackY {\n      top: 0;\n      height: 100%;\n    }\n\n    .employees__grid {\n      display: block;\n    }\n\n    .searchBlock {\n      margin-bottom: 4px;\n    }\n  }\n}\n\n.search {\n  margin-bottom: 4px;\n\n  input {\n    padding-left: 6px;\n  }\n}\n\n.label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 400;\n\n  :global {\n    .btn__icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: initial;\n      transform: none;\n    }\n  }\n\n  &--opened {\n    background: #EEEEEE!important;\n    color: var(--text-color)!important;\n\n    :global {\n      .btn__icon {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  .btn__text-container {\n    max-width: 600px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n\n    @media (max-width: 640px) {\n      max-width: 100%;\n    }\n  }\n\n  &--is-active {\n    background: var(--accent-color);\n    color: var(--white);\n  }\n}\n\n.list-container {\n  overflow: auto;\n  margin-bottom: 16px;\n  max-height: 220px;\n\n  @media (max-width: 1200px) {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    max-height: 320px;\n  }\n}\n\n.item-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  \n  @media (max-width: 1200px) {\n    padding: 4px 0 0;\n    align-items: flex-start;\n  }\n\n  &:last-child {\n    .item {\n      border: none;\n    }\n  }\n}\n\n.checkbox {\n  width: 22px;\n  height: 22px;\n  margin: 0;\n  padding: 0;\n\n  div {\n    margin-top: 0;\n  }\n\n  p {\n    margin: 0!important;\n    padding: 0!important;\n    border-bottom: 0;\n  }\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--gray-100);\n  width: 100%;\n  transition: var(--transition);\n  padding: 6px 4px;\n  cursor: pointer;\n  font-size: 12px;\n  line-height: 16px;\n  gap: 8px;\n\n  @media (hover: hover) {\n    &:hover {\n      background-color: var(--accent-color);\n      color: var(--white);\n\n      .check-icon {\n        svg {\n          path {\n            fill: var(--white);\n          }\n        }\n      }\n    }\n  }\n\n  .check-icon {\n    width: 16px;\n    height: 16px;\n    margin-left: auto;\n\n    svg {\n      fill: var(--accent-color);\n    }\n  }\n\n  @media (max-width: 1200px) {\n    padding: 0 0 14px 0;\n\n    font-size: 14px;\n  }\n}\n\n.avatar {\n  width: 24px;\n  height: 24px;\n}\n\n.btn-container {\n  display: flex;\n  gap: 4px;\n  margin-top: 8px;\n  justify-content: flex-end;\n\n  button {\n    padding: 6px 18px;\n    height: auto;\n    border-radius: 8px;\n    \n    &:last-child {\n      width: 100%;\n      max-width: 160px;\n\n      @media (max-width:1200px) {\n        max-width: initial;\n      }\n    }\n  }\n}\n\n.members {\n\n  &__one {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  &__more {\n    display: flex;\n  }\n\n  .member-avatar {\n    position: relative;\n    width: 16px;\n    height: 16px;\n    border: 1px solid var(--accent-color);\n    font-size: 7px;\n  }\n\n  .member-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n\n}\n\n.fake-input {\n  display: flex;\n  align-items: center;\n  padding: 6px;\n  background: #F0F1F5;\n  border-radius: 4px;\n  width: 100%;\n  margin-bottom: 4px;\n\n  &__date {\n    color: var(--text-color);\n    font-size: 14px;\n    line-height: 22.12px;\n  }\n\n  &__icon {\n    width: 16px;\n    height: 16px;\n    margin-left: auto;\n  }\n}\n\n.datepicker-container {\n  display: flex;\n  position: relative;\n\n  :global {\n    .multiPicker__wp {\n      width: 100%;\n\n      .multiPicker {\n        position: initial;\n        padding: 0;\n        border: none;\n        box-shadow: none;\n      }\n    }\n  }\n}\n\n.nothingListContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.skeleton {\n  width: 100%;\n  height: 37px;\n}\n\n.no-results {\n  text-align: center;\n  font-size: 16px;\n  line-height: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Filter_wrap__hU8xs`,
	"drop": `Filter_drop__SLR7C`,
	"search": `Filter_search__OmpVc`,
	"label": `Filter_label__CLSp2`,
	"label--opened": `Filter_label--opened__NZtGm`,
	"btn__text-container": `Filter_btn__text-container__k9da8`,
	"label--is-active": `Filter_label--is-active__JK0sT`,
	"list-container": `Filter_list-container__RqkGb`,
	"item-container": `Filter_item-container__ruXxx`,
	"item": `Filter_item__5TZpW`,
	"checkbox": `Filter_checkbox__LGFwZ`,
	"check-icon": `Filter_check-icon__fMiBR`,
	"avatar": `Filter_avatar__1kW7+`,
	"btn-container": `Filter_btn-container__L12an`,
	"members__one": `Filter_members__one__OMQUC`,
	"members__more": `Filter_members__more__1hoN2`,
	"members": `Filter_members__Gpqcz`,
	"member-avatar": `Filter_member-avatar__2XGM0`,
	"member-container": `Filter_member-container__M3W1q`,
	"fake-input": `Filter_fake-input__KR2-u`,
	"fake-input__date": `Filter_fake-input__date__2zKFm`,
	"fake-input__icon": `Filter_fake-input__icon__fen-W`,
	"datepicker-container": `Filter_datepicker-container__Rrjc1`,
	"nothingListContainer": `Filter_nothingListContainer__u1DgQ`,
	"skeleton": `Filter_skeleton__luTwb`,
	"no-results": `Filter_no-results__3XkDA`
};
export default ___CSS_LOADER_EXPORT___;
